// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".callout{background:#edf2ff;padding:0.75rem;border-radius:7px}.callout i{margin-right:0.75rem !important;color:#a9b3cb !important;font-size:1.1rem}.callout>p{margin:0;font-weight:500;display:flex;align-items:center}\n", ""]);
// Exports
module.exports = exports;
